export default `float e, j, s, k;
  e = 0.0;
  float t = 0.0; 
  float n = 9.0;
  k = t / n;
  p = vec3( log( length( p ) ) ,( atan( p.z, p.x ) - k ) / PI, sin( p.y / n + k ) );
  for ( s = j = 1.0; j++ < n; p = 3.0 - abs( p * e ) )
    p.y -= round( p.y ),
    s *= e = 3.0 / min( dot( p, p ), 1.0 );
  return e = length( p ) / s;
}`